'use strict';

function XHRHeaders(headerText) {
  /**
   * The headers
   *
   * @type {Object.<string, string>
   * @protected
   */
  this._headers = {};

  this._init(headerText);
}

XHRHeaders.prototype._init = function(headerText) {
  if (headerText) {
    var headerPairs = headerText.split('\u000d\u000a');
    for (var i = 0; i < headerPairs.length; i++) {
      var headerPair = headerPairs[i];
      // Can't use split() here because it does the wrong thing
      // if the header value has the string ": " in it.
      var index = headerPair.indexOf('\u003a\u0020');
      if (index > 0) {
        var key = headerPair.substring(0, index).toLowerCase();
        var val = headerPair.substring(index + 2);
        this._headers[key] = val;
      }
    }
  }
};

XHRHeaders.prototype.get = function(key) {
  return this._headers[key.toLowerCase()] || null;
};

XHRHeaders.prototype.has = function(key) {
  return this._headers.hasOwnProperty(key.toLowerCase());
};

module.exports = XHRHeaders;
